import React, { useState } from 'react';
import { getWhatsAppUrl } from '../lib/whatsapp';
import { LegalModal } from './LegalModal';
import { AvisoLegalContent, PoliticasContent } from './LegalContent';
type LegalView = null | 'politicas' | 'aviso';
export function Footer() {
  const [openView, setOpenView] = useState<LegalView>(null);
  return <>
      <footer className="bg-[#030712] text-slate-400 py-14 border-t border-white/5" data-id="element-115">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-116">
          {/* Brand */}
          <div className="flex items-center justify-center mb-6" data-id="element-117">
            <img src="https://cdn.magicpatterns.com/uploads/kg43cwPFsTeJ6gPr67eY8G/Bitzen-logo-Final_350.png" alt="Bitzen eCommerce" className="h-10 w-auto opacity-90" data-id="element-118" />
          </div>

          <p className="text-sm font-semibold tracking-wide text-slate-300 uppercase mb-4" data-id="element-119">
            Copyright BITZEN ECOMMERCE — Todos los derechos reservados
          </p>

          {/* Legal links */}
          <div className="flex items-center justify-center gap-6 mb-8 text-sm" data-id="element-120">
            <button onClick={() => setOpenView('politicas')} className="text-accent hover:text-accent-light underline underline-offset-4 transition-colors font-medium" data-id="element-121">
              Políticas
            </button>
            <span className="text-slate-700" data-id="element-122">|</span>
            <button onClick={() => setOpenView('aviso')} className="text-accent hover:text-accent-light underline underline-offset-4 transition-colors font-medium" data-id="element-123">
              Aviso Legal
            </button>
            <span className="text-slate-700" data-id="element-124">|</span>
            <a href={getWhatsAppUrl()} target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent-light underline underline-offset-4 transition-colors font-medium" data-id="element-125">
              WhatsApp
            </a>
          </div>

          {/* Disclaimers */}
          <div className="space-y-4 text-xs text-slate-500 leading-relaxed max-w-3xl mx-auto" data-id="element-126">
            <p data-id="element-127">
              Esta página web es operada y mantenida por BITZEN ECOMMERCE. El
              uso del sitio web se rige por sus Términos de Servicio y Política
              de Privacidad.
            </p>

            <p data-id="element-128">
              BITZEN ECOMMERCE es una empresa de educación y capacitación en
              ventas y marketing. No vendemos una oportunidad de negocio, ni
              programas para "hacerse rico rápido" o un sistema para ganar
              dinero. Creemos que, con educación, las personas pueden estar
              mejor preparadas para tomar decisiones de inversión, pero no
              garantizamos el éxito en nuestra capacitación. No hacemos
              afirmaciones sobre ganancias, esfuerzos o afirmaciones de que
              nuestra capacitación le hará ganar dinero. Todo el material es
              propiedad intelectual y está protegido por derechos de autor.
              Cualquier duplicación, reproducción o distribución está
              estrictamente prohibida. Consulte nuestra Divulgación completa
              para obtener detalles importantes.
            </p>

            <p data-id="element-129">
              Las declaraciones y representaciones son opiniones, hallazgos o
              experiencias de personas que generalmente han comprado educación y
              capacitación. Los resultados varían, no son típicos y dependen del
              esfuerzo, el tiempo y la habilidad individuales, así como de
              condiciones desconocidas y otros factores. No medimos ganancias ni
              rendimiento financiero. En cambio, rastreamos transacciones
              completadas y satisfacción de los servicios mediante encuestas
              voluntarias. Los resultados muestran que la mayoría de los
              clientes de Capacitación Avanzada que aplican la capacitación. Sin
              embargo, no debe equiparar las transacciones de cierre de ventas
              completadas con transacciones exitosas. Además, muchos clientes no
              continúan con el programa, no aplican lo que aprenden o intentan
              aplicar lo que aprenden pero aún así tienen dificultades para
              lograr que las ventas sean exitosas para ellos.
            </p>

            <p data-id="element-130">
              Usamos cookies para ayudar a mejorar, promover y proteger nuestros
              servicios. Al continuar usando este sitio, acepta nuestra política
              de privacidad, aviso legal y términos de uso.
            </p>

            <p data-id="element-131">
              Este sitio no es parte del sitio web de Facebook ni de Facebook,
              Inc.
            </p>

            <p data-id="element-132">
              Este sitio NO está respaldado por Facebook de ninguna manera.
              FACEBOOK es una marca registrada de FACEBOOK, Inc.
            </p>

            <p className="text-slate-600 pt-2" data-id="element-133">Aviso Legal Agencias</p>
          </div>

          <div className="border-t border-white/5 mt-10 pt-6 text-xs text-slate-600" data-id="element-134">
            <p data-id="element-135">© 2026 Bitzen eCommerce · BitzenEscala™ · Chile</p>
            <p className="mt-2 max-w-2xl mx-auto" data-id="element-136">
              Evaluación inicial sujeta a revisión del caso. Las ventas dependen
              de producto, oferta, tráfico, operación comercial y seguimiento.
            </p>
          </div>
        </div>
      </footer>

      <LegalModal isOpen={openView === 'aviso'} onClose={() => setOpenView(null)} title="Aviso Legal — Términos de Uso del Sitio y Condiciones de Contratación" data-id="element-137">
        <AvisoLegalContent data-id="element-138" />
      </LegalModal>

      <LegalModal isOpen={openView === 'politicas'} onClose={() => setOpenView(null)} title="Políticas de Privacidad" data-id="element-139">
        <PoliticasContent data-id="element-140" />
      </LegalModal>
    </>;
}